import _ from 'lodash'
import {generateBidders as ixGenerateBidders}  from './bidders/ix_generator';
// import {generateBidders as emxGenerateBidders} from './bidders/emx_generator';
import {generateBidders as appnexusGenerateBidders} from './bidders/appnexus_generator';
import {generateBidders as openxGenerateBidders} from './bidders/openx_generator';

const bidderGenFuncs = [];
bidderGenFuncs.push(ixGenerateBidders);
// bidderGenFuncs.push(emxGenerateBidders);
bidderGenFuncs.push(appnexusGenerateBidders);
bidderGenFuncs.push(openxGenerateBidders);

export function generateAllBidders(adUnit, sizes) {
  return _.reduce(bidderGenFuncs, (bidders, currGenFunc) => {
    bidders = _.assign(bidders, currGenFunc(adUnit, sizes))
    return bidders;
  }, {})
}
